import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Dropdown,
  Row,
  Table,
  Input,
  message,
  Cascader,
  Tag,
  Spin,
  Select,
} from "antd";
import { MoreOutlined, LoadingOutlined } from "@ant-design/icons";
import { Link, Outlet } from "react-router-dom";
import { fetchEndpointGroups } from "../../../common/functions";
import AddGroupModal from "./AddEndpointGroup";
import AddUsertogroup from "./AddEpmUserGroup";
import EditEpmGroupModal from "./EditEndpointGroup";
import EpmGroupAuthflow from "./EpmGroupAuthflow";
import { AUTH_TOKEN, REACT_APP_PAM_API, ORG_ID, DOMAIN_ID } from "../../../constants";
import axios from "axios";
import { logOutUser } from "../../../common";
import { useDebounce } from "../../../common/debounce";
import { AutoComplete } from "antd";
import { Plus } from "lucide-react";
import { AN_COLORS } from "../../../design-system/tokens";
import {
  CountChip,
  FilterCard,
  FilterField,
  MonoCell,
  PageHeader,
  PageShell,
  RowActionMenu,
  TableCard,
  anTableProps,
  tableEmpty,
} from "../../../design-system/tableUi";
export default function EndpointGroups() {
  const [endpointGroups, setEndpointGroups] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [endpointFilter, setEndpointFilter] = useState("");
  const [endpoints, setEndpoints] = useState([]);
  const [isAddgroup, setIsAddgroup] = useState(false);
  const [IsaddUsertogroup, setIsaddUsertogroup] = useState(false);
  const [selectedRecords, setSelectedRecords] = useState(null);
  const [totalRecords, setTotalRecords] = useState(1);
  const [IsGroupauthflow, setIsGroupauthflow] = useState(false);
  const [isEditgroup, setIsEditgroup] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [notification, setNotification] = message.useMessage();
  const [filterBy, setfilterBy] = useState("");
  const [filteredValue, setFilteredValue] = useState("");
  const [sortModel, setSortModel] = useState([]);
  const [search, setSearch] = useState("");

  const [searchQuery, setSearchQuery] = useState("");

  const debouncedSearchValue = useDebounce(searchQuery, 500);

  const debouncedValue = useDebounce(search, 500);

  //pagination
  const [paginationParams, setPaginationParams] = useState({
    current: 1,
    pageSize: 10,
  });
  const [totalCount, setTotalCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(0);
  const PAGESIZE = 10;
  const [currentPageModel, setCurrentPageModel] = useState({
    pageSize: PAGESIZE,
    page: 0,
  });

  const { Option } = Select;

  const [options, setOptions] = useState([]);

  const handleSearch = (value) => {
    if (!value) {
      setOptions([]);
      return;
    }
    const filteredOptions = endpointGroups
      .filter((endpointgroups) =>
        endpointgroups.groupName.toLowerCase().includes(value.toLowerCase())
      )
      .map((endpointgroups) => ({
        label: endpointgroups.groupName,
        value: endpointgroups.groupName,
      }));

    setOptions(filteredOptions);
  };

  const handleSelect = (value) => {
    setSearchQuery(value);
    setPaginationParams({ current: 1, pageSize: 10 });
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log("selectedRowKeys:", selectedRowKeys, "selectedRows: ", selectedRows);
      setSelectedRowKeys(selectedRowKeys, selectedRows);
    },
    onSelect: (e, ef) => {
      console.log(e, ef);
    },
  };

  const handleSortModelChange = (model) => {
    setSortModel(model);
  };

  useEffect(() => {
    fetchInstance();
  }, []);

  // useEffect(() => {
  //   setPaginationParams({ ...paginationParams, current: 1 });
  // }, [endpointFilter]);

  useEffect(() => {
    fetchEndpointGroup();
  }, [debouncedSearchValue, filteredValue, currentPage, paginationParams]);

  const handleTableChange = (pagination, filters, sorter) => {
    setPaginationParams(pagination);

    if (pagination.pageSize !== paginationParams.pageSize) {
      setEndpointGroups([]);
    }
  };

  const fetchEndpointGroup = async () => {
    let DOMAIN_ID = localStorage.getItem("DomainId");

    let pageDetails = {
      domainId: DOMAIN_ID,
      pageId: currentPage + 1,
      pageSize: currentPageModel.pageSize,
      token: AUTH_TOKEN(),
      search: searchQuery,
      filter: {
        filterBy: filterBy,
        value: filteredValue,
      },
      orgId: ORG_ID(),
    };
    setLoadingData(true);
    try {
      let res = await axios.post(
        `${REACT_APP_PAM_API}/instanceGroup/listEndpointGroup`,
        pageDetails,
        {
          headers: {
            "X-Authorization": AUTH_TOKEN(),
            withCredentials: true,
          },
        }
      );
      const originalGroups = res?.data?.groups;

      // Adding an 'id' property to each object
      const groupsWithId = originalGroups.map((group, index) => ({
        ...group,
        id: index + 1, // You can use a different logic to generate IDs if needed
      }));
      setEndpointGroups(groupsWithId ?? []);
      console.log(endpointGroups);
      // setTotalRecords(res?.data?.totalCount);
      setLoadingData(false);
      setTotalCount(res?.data?.totalCount);
      setCurrentPageModel({
        pageSize: 10,
        page: currentPage,
      });
    } catch (err) {
      setLoadingData(false);
      if (err?.response?.data?.message === "Invalid credentials" || err?.response?.status === 401) {
        notification.open({
          type: "error",
          content: "Credentials are invalid",
        });
        logOutUser();
      } else {
        notification.open({
          type: "error",
          content: "Error fetching Endpoint Groups",
        });
      }
    }
  };

  const deleteEndpointGroup = async (record) => {
    let id = [];
    id.push(Number(record.groupId));
    console.log(record);
    let data = {
      domainId: DOMAIN_ID(),
      id: id,
      token: AUTH_TOKEN(),
      orgId: ORG_ID(),
    };
    let url = `${REACT_APP_PAM_API}/instanceGroup/deleteEndpointGroup`;
    try {
      await axios.delete(url, {
        data: data,
        headers: {
          "X-Authorization": AUTH_TOKEN(),
          withCredentials: true,
        },
      });

      await fetchEndpointGroup();
      notification.open({
        type: "success",
        content: `Endpoint Group Deleted`,
      });
    } catch (err) {
      if (err.response.data.message == "Invalid credentials") {
        logOutUser();
        notification.open({
          type: "error",
          content: `Credentials are invalid`,
        });
      } else if (err.response.status == 401) {
        logOutUser();
      } else {
        notification.open({
          type: "error",
          content: `Error Deleting Endpoint Group`,
        });
      }
    } finally {
      fetchEndpointGroup();
    }
  };

  const fetchInstance = () => {
    let pageDetails = {
      domainId: DOMAIN_ID(),
      pageId: 1,
      pageSize: 100,
      search: searchQuery,
      filter: {
        filterBy: "",
        value: "",
      },
      token: AUTH_TOKEN(),
      orgId: ORG_ID(),
      MachineType: "endpoint",
    };

    axios
      .post(`${REACT_APP_PAM_API}/instances/list`, pageDetails, {
        headers: {
          withCredentials: true,
          "X-Authorization": AUTH_TOKEN(),
        },
      })
      .then((res) => {
        setEndpoints(res?.data?.instances || []);
      })
      // .then((res) => {
      //   setEndpoints(
      //     res.data.instances.map((instance) => ({
      //       value: instance.instanceId,
      //       hostName: instance.hostName,
      //       label: (
      //         <div>
      //           {instance.hostName} <b>{`(${instance.publicIp})`}</b>
      //         </div>
      //       ),
      //     }))
      //   );
      // })
      .catch((err) => {
        if (
          err?.response?.data?.message === "Invalid credentials" ||
          err?.response?.status === 401
        ) {
          notification.open({
            type: "error",
            content: "Credentials are invalid",
          });
          logOutUser();
        } else {
          notification.open({
            type: "error",
            content: "Unable to fetch endpoints",
          });
        }
      });
  };


  // const handleFilter = (_, data) => {
  //   console.log(data);
  //   setfilterBy(data ? data[0]?.value : "");
  //   setFilteredValue(data ? data[1]?.hostName : "");
  //   setPaginationParams({ current: 1, pageSize: 10 });
  // };

  const handleFilter = (value) => {
    if (value) {
      const selectedOption = endpoints.find(
        (option) => option.hostName === value || option.instanceId === value
      );

      if (selectedOption) {
        setfilterBy("endpoints");
        setFilteredValue(selectedOption.hostName || "");
      }
    } else {
      setfilterBy("");
      setFilteredValue("");
    }

    setPaginationParams({ current: 1, pageSize: 10 });
  };


  const groupDetailState = (row) => {
    localStorage.removeItem("endpointGroupDetails");
    localStorage.setItem(
      "endpointGroupDetails",
      JSON.stringify({ groupName: row.groupName, groupId: row.groupId }),
    );
  };

  const columns = [
    {
      title: "Group name",
      key: "groupName",
      render: (_, row) => (
        <Link
          to="/pam/endpointGroups/endpointGroupDetails"
          state={{ groupName: row.groupName, groupId: row.groupId }}
          onClick={() => groupDetailState(row)}
          style={{ fontWeight: 500, color: AN_COLORS.ink }}
        >
          {row.groupName || "—"}
        </Link>
      ),
    },
    {
      title: "Endpoints",
      key: "hostName",
      render: (_, row) => <MonoCell>{row.hostName}</MonoCell>,
    },
    {
      title: "Users",
      key: "usersCount",
      width: 110,
      render: (_, row) =>
        row.usersCount ? (
          <Link
            to="/pam/endpointGroups/endpointGroupDetails?selectedTab=endpointUsers"
            state={{ groupName: row.groupName, groupId: row.groupId }}
            onClick={() => groupDetailState(row)}
          >
            {row.usersCount}
          </Link>
        ) : (
          // Zero users means there is nothing to open. The old link was
          // rendered disabled, which still looked clickable.
          <span style={{ color: AN_COLORS.muted }}>0</span>
        ),
    },
    {
      title: "",
      key: "action",
      width: 56,
      render: (_, row) => (
        <RowActionMenu
          items={[
            { key: "auth-flow", label: "Auth flow", onClick: () => { setSelectedRecords(row); setIsGroupauthflow(true); } },
            { key: "edit-group", label: "Edit group", onClick: () => { setSelectedRecords(row); setIsEditgroup(true); } },
            { type: "divider" },
            { key: "delete-group", danger: true, label: "Delete", onClick: () => deleteEndpointGroup(row) },
          ]}
        />
      ),
    },
  ];

  const applied = [
    searchQuery && { key: "name", label: `Name: ${searchQuery}`, clear: () => setSearchQuery("") },
  ].filter(Boolean);

  return (
    <PageShell>
      {setNotification}

      <PageHeader
        eyebrow="PAM · Targets"
        title="Endpoint Groups"
        subtitle="Collections of endpoints that share an authentication flow and a set of endpoint users."
        chips={<CountChip count={totalCount} label={totalCount === 1 ? "Group" : "Groups"} />}
        actions={
          <Button type="primary" icon={<Plus size={13} strokeWidth={2.2} />} onClick={() => setIsAddgroup(true)}>
            Add group
          </Button>
        }
      />

      <FilterCard
        columns="1.6fr 1fr 1fr"
        applied={applied}
        onClearAll={() => setSearchQuery("")}
        showing={endpointGroups.length}
        total={totalCount}
      >
        <FilterField label="Search group name">
          <AutoComplete
            placeholder="Search group name"
            allowClear
            onSearch={handleSearch}
            options={options}
            onSelect={setSearch}
            onChange={setSearchQuery}
            style={{ width: "100%", height: 36 }}
          />
        </FilterField>

        <FilterField label="Endpoint">
          <Select
            showSearch
            allowClear
            placeholder="Any endpoint"
            onChange={handleFilter}
            style={{ width: "100%", height: 36 }}
            optionFilterProp="label"
            options={endpoints.map((e) => ({
              value: e.hostName || e.instanceId,
              label: `${e?.hostName} (${e?.publicIp})`,
            }))}
          />
        </FilterField>
        <div />
      </FilterCard>

      <TableCard>
        <Table
          {...anTableProps}
          columns={columns}
          dataSource={endpointGroups}
          rowKey={(r) => r.groupId ?? r.id ?? r.groupName}
          loading={loadingData}
          locale={tableEmpty(loadingData, applied.length ? "No groups match your filters." : "No endpoint groups yet.")}
          pagination={{
            current: currentPage + 1,
            pageSize: currentPageModel?.pageSize || 10,
            total: totalCount,
            showSizeChanger: false,
            onChange: (p) => setCurrentPage(p - 1),
          }}
        />
      </TableCard>


      <Outlet />
      {isAddgroup && (
        <AddGroupModal
          isAddgroup={isAddgroup}
          setIsAddgroup={setIsAddgroup}
          fetchepmGroups={fetchEndpointGroups}
        />
      )}

      {IsaddUsertogroup && (
        <AddUsertogroup
          IsaddUsertogroup={IsaddUsertogroup}
          setIsaddUsertogroup={setIsaddUsertogroup}
          selectedRecords={selectedRecords}
        />
      )}

      {isEditgroup && (
        <EditEpmGroupModal
          isEditgroup={isEditgroup}
          setIsEditgroup={setIsEditgroup}
          selectedRecords={selectedRecords}
          endpoints={endpoints}
          fetchepmGroups={fetchEndpointGroup}
        />
      )}

      {IsGroupauthflow && (
        <EpmGroupAuthflow
          IsGroupauthflow={IsGroupauthflow}
          setIsGroupauthflow={setIsGroupauthflow}
          selectedRecords={selectedRecords}
        />
      )}
    </PageShell>
  );
}
